import { Moon, Sun } from "lucide-react";
import { useTheme } from "./ThemeProvider";

export default function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label="Toggle theme"
      className={`relative inline-flex h-9 w-9 items-center justify-center border border-border text-foreground/80 hover:text-accent hover:border-accent transition-colors duration-300 ${className}`}
    >
      {theme === "light" ? <Moon size={15} strokeWidth={1.25} /> : <Sun size={16} strokeWidth={1.25} />}
    </button>
  );
}
